import uuid from 'uuid/v4'
import Platform from 'platform'
import { CAROUSEL_ITEM_THUMBNAIL } from './config/Thumbnail'

const PLATFORM = ['chrome', 'firefox', 'safari', 'android', 'ios']

export const parseQuery = queryString => {
  return queryString
    .slice(1)
    .split('&')
    .map(q => q.split('='))
    .reduce((acc, cur) => {
      acc[cur[0]] = cur[1]
      return acc
    }, {})
}

export const getDeviceId = () => {
  let deviceId = localStorage.getItem('device_uuid')

  if (deviceId) {
    return deviceId
  }

  const uid = uuid()

  localStorage.setItem('device_uuid', uid)
  return uid
}

export const generateDeviceInfo = () => {
  let platform = Platform.name.toLowerCase().split(' ')[0]

  if (PLATFORM.indexOf(platform) === -1) {
    const alternativePlatform = Platform.os.family.toLowerCase()

    if (PLATFORM.indexOf(alternativePlatform) !== -1) {
      platform = alternativePlatform
    } else {
      platform = 'chrome'
    }
  }

  return {
    uuid: getDeviceId(),
    name: Platform.os.family || 'Unknown',
    platform,
    osVersion: Platform.os.version || 'Unknown',
    screen: 'web'
  }
}

export const generateDetailUrl = data => {
  let type

  switch (data.type) {
    case 'season':
    case 'featured':
    case 'editorial':
      type = 'playlists'
      break
    case 'webview':
      type = 'live'
      break
    case 'stream':
      if(data.interactive) {
        type = 'stream';
      } else {
        type = 'live';
      }
      break

    default:
      type = data.type
  }
  return `/${type}/${data.id}`
}

export const generatePlaylistUrl = id => {
  return `/playlists/${id}`
}

export const generateGenres = tags => {
  const genres = tags && tags.genres

  return genres && genres.length && genres.join('/')
}

export const generateCasts = tags => {
  const casts = tags && tags.casts

  return casts && casts.length && casts.join(', ')
}

export const formatDuration = num => {
  const hours = num / 60
  const rhours = Math.floor(hours)
  const minutes = (hours - rhours) * 60
  const rminutes = Math.round(minutes)
  return rhours + 'h' + rminutes + 'm'
}

export const getThumbnail = (item, type) => {
  if (type === CAROUSEL_ITEM_THUMBNAIL) {
    if (window.innerWidth <= 500) {
      return (
        item.attachments &&
        item.attachments.banner_portrait &&
        item.attachments.banner_portrait.fileUrl
      )
    }
  }

  return (
    item.attachments && item.attachments[type] && item.attachments[type].fileUrl
  )
}

export const getDetailPoster = item => {
  if (item.type === 'episode') {
    return (
      item.attachments &&
      item.attachments.thumbnail_landscape &&
      item.attachments.thumbnail_landscape.fileUrl
    )
  }

  return (
    item.attachments &&
    item.attachments.poster_landscape &&
    item.attachments.poster_landscape.fileUrl
  )
}

export const mergeArrayObjects = (firstArray, secondArray) => {
  return firstArray.map(first => {
    const selected = secondArray.find(second => second.id === first.id)
    if (selected) {
      return {
        ...first,
        ...selected
      }
    }
    return first
  })
}

export const detectAgent = type => {
  if (window.navigator) {
    const isSuitableAgent = /iPhone|iPad|iPod|Android/i.test(
      navigator.userAgent
    )
    const deviceWidth = window.innerWidth
    if (type === 'mobile') return isSuitableAgent && deviceWidth <= 500
    if (type === 'tablet') return isSuitableAgent && deviceWidth >= 768
  }
  return false
}

export const detectOS = () => {
  return Platform.os && Platform.os.family && Platform.os.family.toLowerCase()
}

export const capitalizeFirstLetter = string => {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export const secondsToTime = length => {
  let hours = Math.floor(length / 3600)
  let minutes = Math.floor((length - hours * 3600) / 60)
  let seconds = Math.floor(length - hours * 3600 - minutes * 60)
  let time = ''

  if (hours !== 0) {
    time = hours + ':'
  }
  if (minutes !== 0 || time !== '') {
    minutes = minutes < 10 && time !== '' ? '0' + minutes : String(minutes)
    time += minutes + ':'
  }
  if (time === '') {
    time = seconds + 's'
  } else {
    time += seconds < 10 ? '0' + seconds : String(seconds)
  }
  return time
}
